import { getEnvs } from '@/shared/utils';
const { VITE_BUCKET_BASE } = getEnvs();
import { MRT_ColumnDef } from "material-react-table";
import { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";

import { PermissionsEnum } from "@/auth/interfaces";
import {
  ROUTER_PATHS,
  TABLE_CONSTANTS,
  emptyCellOneLevel,
  hasAllPermissions,
  hasPermission,
  plantillaExcelENUM,
  useCheckPermissions,
  useTableServerSideFiltering,
  useUploadFile,
} from "@/shared";
import { useDeleteOLT, useFetchOLTs } from "@/shared/actions/erp";
import {
  CustomSearch,
  GeneralTable,
  SingleButton,
  SingleTableBoxScene,
} from "@/shared/components/ui";
import { useTableFilter } from "@/shared/hooks/useTableFilter";
import { OLT } from "@/shared/interfaces";
import { useUiConfirmModalStore } from "@/store/ui";
import { SAVE_OLT_PERMISSIONS } from "../../shared/constants";
import { Download } from '@mui/icons-material';
import ModalGenerarReportesOLTs from '../../shared/components/ModalGenerarReportesOLTs';

export type OLTsPageProps = {};

const OLTsPage: React.FC<OLTsPageProps> = () => {
  useCheckPermissions(PermissionsEnum.api_view_olt);

  const returnUrlOLTsPage = ROUTER_PATHS.configuracionRED.oltNav;
  const [openModalReporteOLTs, setOpenModalReporteOLTs] = useState<boolean>(false);

  const navigate = useNavigate();

  ///* global state
  const setConfirmDialog = useUiConfirmModalStore((s) => s.setConfirmDialog);
  const setConfirmDialogIsOpen = useUiConfirmModalStore(
    (s) => s.setConfirmDialogIsOpen
  );

  const deleteOLT = useDeleteOLT();

  ///* table
  const {
    globalFilter,
    pagination,
    searchTerm,
    onChangeFilter,
    setPagination,
    cleanFilter,
  } = useTableFilter();
  const { pageIndex, pageSize } = pagination;
  const { filterObject, columnFilters, setColumnFilters } =
        useTableServerSideFiltering();

  ///* fetch data
  const {
    data: OLTPagingRes,
    isLoading,
    isRefetching,
  } = useFetchOLTs({
    params: {
      page: pageIndex + 1,
      page_size: pageSize,
      nombre: searchTerm,
      ...filterObject,
    },
  });

  ///* handlers

  const onEdit = (olt: OLT) => {
    setConfirmDialog({
      isOpen: true,
      title: "Editar OLT",
      subtitle: "¿Está seguro que desea editar este OLT?",
      onConfirm: () => {
        setConfirmDialogIsOpen(false);
        navigate(`${returnUrlOLTsPage}/editar/${olt.id_olt}`);
      },
    });
  };

  const onDelete = (olt: OLT) => {
    setConfirmDialog({
      isOpen: true,
      title: "Eliminar OLT",
      subtitle: "¿Está seguro que desea eliminar este OLT?",
      onConfirm: () => {
        setConfirmDialogIsOpen(false);
        deleteOLT.mutate(olt.id_olt!);
      },
    });
  };

  const columns = useMemo<MRT_ColumnDef<OLT>[]>(
    () => [
      {
        accessorKey: "nombre",
        header: "Nombre",
        size: 180,
        Cell: ({ row }) => emptyCellOneLevel(row, "nombre"),
      },
      {
        accessorKey: "user",
        header: "Usuario",
        size: 180,
        Cell: ({ row }) => emptyCellOneLevel(row, "user"),
      },
      {
        accessorKey: "hostname",
        header: "Hostname",
        size: 180,
        Cell: ({ row }) => emptyCellOneLevel(row, "hostname"),
      },
      // {
      //   accessorKey: "password",
      //   header: "Password",
      //   size: 180,
      //   Cell: ({ row }) => emptyCellOneLevel(row, "password"),
      // },
      {
        accessorKey: "puerto",
        header: "Puerto",
        size: 180,
        Cell: ({ row }) => emptyCellOneLevel(row, "puerto"),
      },

      // // fk ---------------------
      // {
      //   accessorKey: "pais_nombre", // to allow filtering
      //   header: "País",
      //   size: 200,
      //   Cell: ({ row }) => row.original?.pais_data?.nombre || "N/A",
      // },
      // {
      //   accessorKey: "provincia_nombre",
      //   header: "Provincia",
      //   size: 200,
      //   Cell: ({ row }) => row.original?.provincia_data?.nombre || "N/A",
      // },
      // {
      //   accessorKey: "ciudad_nombre",
      //   header: "Ciudad",
      //   size: 200,
      //   Cell: ({ row }) => row.original?.ciudad_data?.nombre || "N/A",
      // },
      // {
      //   accessorKey: "zona_nombre",
      //   header: "Zona",
      //   size: 200,
      //   Cell: ({ row }) => row.original?.zona_data?.nombre || "N/A",
      // },
      // {
      //   accessorKey: "sector",
      //   header: "Sector",
      //   size: 180,
      //   Cell: ({ row }) => {
      //     return row.original.sector_data?.nombre || "N/A";
      //   },
      // },

      {
        accessorKey: "coordenadas",
        header: "Coordenadas",
        size: 180,
        Cell: ({ row }) => emptyCellOneLevel(row, "coordenadas"),
      },
      {
        accessorKey: 'estado',
        header: 'Estado',
        size: 200,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) => (
          <span>{row.original.estado ? 'ACTIVO' : 'INACTIVO'}</span>
        ),
        // Cell: ({ row }) => (
        //     <SwitchComponente
        //     estadoSwitch={row.original.estado || false}
        //     titulo={row.original.estado ? 'Activo' : 'Inactivo'}
        //     setEstadoSwitch={estado => {
        //         if (!hasPermission(PermissionsEnum.api_change_nap)) return;
        //         setConfirmDialog({
        //         isOpen: true,
        //         title: 'Cambiar Estado',
        //         subtitle:
        //             '¿Está seguro que desea cambiar el estado de este registro ?',
        //         onConfirm: () => {
        //             setConfirmDialogIsOpen(false);
        //             if(!row.original.caja_primaria && estado){
        //             toast.error('No se puede activar un NAP que no tenga una caja primaria');
        //             return; 
        //             }
        //             updateNapsMutation.mutate({
        //             id: row.original.id_nap!,
        //             data: {
        //                 ...row.original,
        //                 estado: estado as boolean,
        //             },
        //             });
        //         },
        //         });
        //     }}
        //     />
        // ),
      },
      // {
      //   accessorKey: "descripcion",
      //   header: "Descripción",
      //   size: 180,
      //   Cell: ({ row }) => emptyCellOneLevel(row, "descripcion"),
      // },
    ],
    []
  );

  //CUSTOM HOOKS

  const { fileInputRef: importOLTs, handleImportarOLT } = useUploadFile();

  return (
    <SingleTableBoxScene
      title="OLT"
      urlRedirect={`${returnUrlOLTsPage}/crear`}
      enableRedirect={
      hasPermission(PermissionsEnum.generacion_auto_mangas)
      && !hasPermission(PermissionsEnum.api_add_olt)?
      false
      :hasAllPermissions([
        ...SAVE_OLT_PERMISSIONS,
        PermissionsEnum.api_add_olt,
      ])}
      //excel
      enableUploadFile={true}
      enableDownloadFile={true}
      fileInputRef={importOLTs}
      importationName={"Subir OLTs"}
      handleFileUpload={handleImportarOLT}
      importationsQuantity={1}
      urlDownloadPlantilla={
        "/"+VITE_BUCKET_BASE+plantillaExcelENUM.PLANTILLA_OLT
      }
      urlDownloadNameExcel={"plantilla_olt"}
      customContentButtonSide={<>
        {
          hasAllPermissions([
            ...SAVE_OLT_PERMISSIONS,
            PermissionsEnum.generar_reporte_nap,
          ]) && (
            <SingleButton
              label="Reporte"
              startIcon={<Download />}
              color='success'
              onClick={() => setOpenModalReporteOLTs(true)}
            />
          )
        }
      </>}
      // messageInToolTips={[
      //   "El archivo a importar debe contener una sola hoja y cumplir con el formato indicado en la plantilla.",
      //   "El archivo a importar puede tener una hoja o más. Asegúrese que los nombres de las troncales, host y naps se encuentren en la fila y columna correcta según el formato de la plantilla.",
      // ]}
    >
      <CustomSearch
        onChange={onChangeFilter}
        value={globalFilter}
        text="por nombre de OLT"
        cleanFilter={cleanFilter}
      />

      <GeneralTable<OLT>
        columns={columns}
        data={OLTPagingRes?.data?.data || []}
        isLoading={isLoading}
        isRefetching={isRefetching}
        // // search
        enableGlobalFilter={false}
        // // pagination
        pagination={pagination}
        onPaging={setPagination}
        rowCount={OLTPagingRes?.data?.count}
        ///* filters - server side
        enableManualFiltering={true}
        columnFilters={columnFilters}
        onColumnFiltersChange={setColumnFilters}
        // // actions ========
        enableColumnActions={hasAllPermissions([
          ...SAVE_OLT_PERMISSIONS,
        ])}
        actionsColumnSize={TABLE_CONSTANTS.ACTIONCOLUMN_WIDTH}
        // crud
        canEdit={hasAllPermissions([
          ...SAVE_OLT_PERMISSIONS,
        ])}
        onEdit={onEdit}
        canDelete={false}
        onDelete={onDelete}
      />
      <ModalGenerarReportesOLTs open={openModalReporteOLTs} setOpen={setOpenModalReporteOLTs} />
    </SingleTableBoxScene>
  );
};

export default OLTsPage;
